import React from "react";
import PasswordInput from "components/password-input";
import Dropdown from "components/dropdown";
import Input from "components/input";
import clsx from "clsx/lite";

const FieldRenderer = ({ field, formState, errors, setFormState, layout, required }) => {
	const { name, type = "text", placeholder = "", disabled = false, title, options, className, onChange = () => { } } = field;

	if (type === "password" && formState.id) return null;

	const handleChange = (e) => {
		const value = e.target.value;
		onChange(e);
		setFormState((prev) => ({ ...prev, [name]: value }));
	};

	switch (type) {
		case "password":
			return (
				<PasswordInput key={`${layout}-${name}`} error={errors[name]} name={name}
					value={formState[name]} type={type} disabled={disabled} label={title}
					placeholder={placeholder || title} required hideLabel
				/>
			);
		case "dropdown":
			return (
				<div
					key={`${layout}-${name}`}
					className={clsx("relative border border-beige border-opacity-30 p-1 shadow bg-white", className)}
				>
					<Dropdown
						Preview={() => <p className="pr-2">{formState[name] || <span className="opacity-40">{placeholder}</span>}</p>}
						value={formState[name]} id={name} name={name}
						onChange={(e) => handleChange(e)} activeClass="!border-none"
						className="focus-within:!outline-0" required={required}
					>
						{options.map((opt) => (
							<option key={opt} value={opt}>
								{opt}
							</option>
						))}
					</Dropdown>
				</div>
			);
		case "textarea":
			return (
				<textarea key={`${layout}-${name}`} name={name} value={formState[name]}
					disabled={disabled} placeholder={placeholder || title} rows={5}
					className={clsx("border border-beige border-opacity-30 p-2 shadow bg-white w-full resize-none", className)}
					onChange={handleChange} required={required}
				/>
			);
		default:
			return (
				<Input key={`${layout}-${name}`} error={errors[name]} name={name}
					value={formState[name]} type={type} disabled={disabled} placeholder={placeholder || title}
					className={className} required={required} onChange={handleChange}
				/>
			);
	}
};

export default FieldRenderer;